import Styles from './FinalStep.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button/Button'
import { TopBar } from '../TopBar/TopBar'

export interface FinalStepProps {
  onNext: () => void
}

export const FinalStep = ({ onNext }: FinalStepProps) => {
  return (
    <div className={Styles.container}>
      <TopBar highlightStep="generateContent" />
      <div className={Styles.leftSide}>
        <div className={Styles.leftContent}>
          <div className={Styles.texts}>
            <Heading level={4} color="var(--dark-60)">
              🎉 Now, the fun part!
            </Heading>
            <Heading level={1}>Let's generate your first week of content.</Heading>
          </div>
          <Button size="xl" onPress={onNext}>
            Let's go
          </Button>
        </div>
      </div>
      <img
        className={Styles.blazeIllustration}
        alt="blaze illustration"
        src="https://res.cloudinary.com/almanac/image/upload/v1772131541/blaze_assets/virtual_marketer/onboarding/Frame_1171276883_nlqa30.png"
      />
    </div>
  )
}
